import { IDB_actionTypeRead } from '../IDB/IDB.table.actionType'
import { IDB_taskReportRead, IDB_taskReportsWrite } from '../IDB/IDB.table.taskReport'
import type { Type_IActionType, Type_ITaskReport, Type_TTaskData } from '../Type/Type.hive'
import * as sentry from '../../src/utils/sentry'

export async function Rpts_saveTaskReportData(actionTypeID: number, report: Type_TTaskData) {
    const newTaskReport = {
        id: actionTypeID,
        date: new Date(),
        report,
    }

    const oldTaskReport = await IDB_taskReportRead(actionTypeID).catch<Type_ITaskReport>(() => null)
    const actionType = await IDB_actionTypeRead(actionTypeID).catch<Type_IActionType>(() => null)

    if (!report) {
        return sentry.err('Undefined report data while saving the task_report', {
            tags: { context: 'saveTaskReportData' },
        })
    }

    if (!actionType) {
        return sentry.err('Trying to save to an action type that doesnt exist', {
            tags: { context: 'saveTaskReportData' },
        })
    }

    if (oldTaskReport && oldTaskReport.report && report.type !== oldTaskReport.report.type) {
        return sentry.err('Trying to update a report to a different type', {
            tags: { context: 'saveTaskReportData' },
            extra: {
                oldReport: oldTaskReport,
                newReport: newTaskReport,
                actionType,
            },
        })
    }

    if (!reportMatchesActionTypes(actionType, report)) {
        return sentry.err('ActionType does not match report', {
            tags: { context: 'saveTaskReportData' },
            extra: {
                oldReport: oldTaskReport,
                newReport: newTaskReport,
                actionType,
            },
        })
    }

    console.log('Saving "TaskReport"', newTaskReport) // eslint-disable-line no-console
    await IDB_taskReportsWrite([newTaskReport]).catch(() => null)
}

function reportMatchesActionTypes(actionType: Type_IActionType, report: Type_TTaskData) {
    switch (report.type) {
        case 'report':
            return actionType.type === 'report' || actionType.type === 'simple-unit'
        case 'location-form':
            return actionType.type === 'form'
        case 'location-issue':
            return actionType.type === 'process-flow' || actionType.type === 'simple' || actionType.type === 'note'
        case 'unit-form':
            return actionType.type === 'unit-form'
        default:
            return false
    }
}
